import React from "react";
import {Box, Heading, Form, FormField, TextInput, Button, CheckBox,Text} from "grommet";
import TreeViewAree from "../../treeView/TreeView";
import { useLazyQuery,useMutation } from '@apollo/client';
import {UPSERT_AREA} from "./AreaGQL.js";
import { tenant, tenantTypeFirstUpperCase } from "../../tenant";
import { extractIdFormData } from "../../../utilis/utils";
import AreaTrack from "./TracciaCampo";


export default function AddArea(props) {

  const [formData,setFormData]=React.useState({});
  const [mutationArea]=useMutation(UPSERT_AREA);
  const [selectedNodes,setSelectedNodes]=React.useState(formData?.jobs_jobsareas?.map((jobArea)=>jobArea.area_id )||[]);
  const [tree,setTree]=React.useState({});

  React.useEffect(() =>{
    if(props?.elementSel){
       setFormData({...props?.elementSel})
    }
  },[])


  const onChangeTextInput=(event)=>{
    setFormData({...formData,[event.target.name]:event.target.value})
  }

  function onUpsertArea(){
    let obj= extractIdFormData(formData,true,true);
    delete obj?.variables?.input["_Typename"]
    mutationArea(obj)
    .then((value)=>{
      alert("Area aggiunta correttamente");
      setFormData(value);
      onEscLayer();
    }).catch((value)=>{
      console.error(value);
      alert("Errore durante l'operazione");
    })
  }

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }

  let width_value = formData?.id ? 1200 : 700;


  return (
    <Box style={{width:`${width_value}px`}} round pad="medium" direction="column" background="white" align="center" overflow="auto">
      <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
        <Box direction="row" gap="large">
          {!props.elementSel?"INSERISCI AREA":"AGGIORNA AREA"}
        </Box>
      </Heading>
      <Box fill gap="medium" pad={{ vertical: "small" }}>
        <Form style={{marginTop:"50px"}}>
          <Box pad="xsmall">
            <FormField required label="Nome">
              <TextInput
                style={{fontWeight:"bold"}}
                name="name"
                value={ formData?.name }
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
            <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:"20px"}}>
          <Button label={!props.elementSel?"Aggiungi":"Aggiorna nome"} onClick={onUpsertArea} style={{width:'250px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
        </Box>
          </Box>
        </Form>
          <Box pad="xsmall">
            {formData?.id  && 
              <AreaTrack id={formData?.id}></AreaTrack> 
            }
          </Box>
      </Box>
    </Box>
  )
}